import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}) {
  if (!options.headers) {
    options.headers = {}
  }
  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  fetchTACTesting(payload) {
    // Direkter Aufruf auf das Live-Backend
    const url = "https://app.wellcomefit.ch/api/tactesting"
    return axios.post(url, payload, buildOptions()).then((res) => res.data)
  },
  planning: {
    fetchActuals(params = {}) {
      const url = buildUrl("plans/actuals")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchPlans(params = {}) {
      const url = buildUrl("plans")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    savePlan(data) {
      const url = buildUrl("plans")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    fetchManualRevenues(params = {}) {
      const url = buildUrl("plans/manual-revenues")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    saveManualRevenue(data) {
      const url = buildUrl("plans/manual-revenues")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    updateManualRevenue(id, data) {
      const url = buildUrl(`plans/manual-revenues/${id}`)
      return axios.put(url, data, buildOptions()).then((res) => res.data)
    },
    deleteManualRevenue(id) {
      const url = buildUrl(`plans/manual-revenues/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    fetchExpensesDetail(params = {}) {
      const url = buildUrl("plans/actuals/expenses-detail")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchCreditCardFile(id) {
      const url = buildUrl(`plans/actuals/credit-card-file/${id}`)
      return axios.get(url, { ...buildOptions(), responseType: "blob" }).then((res) => res.data)
    },

    csvImport: {
      sync() {
        const url = buildUrl("plans/csv-import/sync")
        return axios.get(url).then((res) => res.data)
      },
      list(status = "pending") {
        const url = buildUrl("plans/csv-import")
        return axios.get(url, buildOptions({ params: { status } })).then((res) => res.data)
      },
      update(id, data) {
        const url = buildUrl(`plans/csv-import/${id}`)
        return axios.patch(url, data, buildOptions()).then((res) => res.data)
      },
      confirm(id) {
        const url = buildUrl(`plans/csv-import/${id}/confirm`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },
      reject(id) {
        const url = buildUrl(`plans/csv-import/${id}/reject`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },
      confirmBulk(ids) {
        const url = buildUrl("plans/csv-import/confirm-bulk")
        return axios.post(url, { ids }, buildOptions()).then((res) => res.data)
      },
    },
  },
}
